import React from 'react';
import { Table } from 'semantic-ui-react';
import EmailIcon from '@/components/EmailIcon';
import { claimStateWithPermissions } from '../state/state';
import TaskClaimButton from './TaskClaimButton';

const TaskAssigneeCell = ({ canEdit, category, task }) => {
  const { claimed, canClaim } = claimStateWithPermissions(task, canEdit);

  return (
    <Table.Cell className="aridhia-task-assignee-cell">
      {claimed && (<EmailIcon email={task.assignee.email} name={task.assignee.name} />)}
      {!claimed && canClaim && (
        <TaskClaimButton
          basic
          category={category}
          className="aridhia-cell-button"
          size="tiny"
          claimStatus={task.claimStatus}
          task={task}
        />
      )}
    </Table.Cell>
  );
};

export default TaskAssigneeCell;
